import styled from '@emotion/styled';
import { colors } from 'Constants/Colors';
import { palette } from 'Constants/Palette';

// Se re-exporta para no romper a los consumidores que ya la importaban de aquí.
export { palette };

export const Page = styled.main`
  position: relative;
  padding: 44px 48px 100px;
  color: ${palette.ink};
`;

export const HeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Logo = styled.div`
  font-size: 20px;
  font-weight: 800;
  color: ${palette.ink};

  b {
    color: ${palette.green};
  }
`;

export const WelcomeSub = styled.div`
  font-size: 14px;
  color: ${palette.muted};

  b {
    color: ${palette.ink};
  }
`;

export const HelpButton = styled.button`
  display: inline-flex;
  align-items: center;
  padding: 8px 10px;
  border: 1px solid ${palette.border};
  border-radius: 999px;
  background: ${colors.WHITE};
  font-family: inherit;
  font-size: 13px;
  font-weight: 600;
  color: ${palette.muted};
  cursor: pointer;
  transition:
    color 0.2s ease,
    border-color 0.2s ease,
    background 0.2s ease,
    box-shadow 0.2s ease;

  span {
    max-width: 0;
    margin-left: 0;
    overflow: hidden;
    white-space: nowrap;
    opacity: 0;
    transition:
      max-width 0.25s ease,
      margin-left 0.25s ease,
      opacity 0.2s ease;
  }

  &:hover {
    border-color: ${palette.track};
    background: ${colors.GREEN_ULTRA_LIGHT};
    color: ${palette.green};
    box-shadow: 0 2px 8px rgba(10, 116, 65, 0.12);

    span {
      max-width: 80px;
      margin-left: 6px;
      opacity: 1;
    }
  }
`;

export const HeroRow = styled.div`
  display: flex;
  gap: 24px;
  align-items: center;
  margin-top: 36px;

  @media (max-width: 1100px) {
    flex-wrap: wrap;
  }
`;

export const Layout = styled.div`
  display: flex;
  gap: 24px;
  align-items: flex-start;

  @media (max-width: 1100px) {
    flex-direction: column;
  }
`;

export const MainCol = styled.div`
  flex: 1;
  min-width: 0;
`;

export const RightRail = styled.aside`
  width: 320px;
  flex-shrink: 0;
  position: sticky;
  top: 24px;

  @media (max-width: 1100px) {
    width: 100%;
    position: static;
  }
`;

export const SectionBlock = styled.div`
  margin-top: 40px;
`;

export const Edcap = styled.div<{ tone?: 'green' | 'muted' }>`
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: ${({ tone }) => (tone === 'green' ? palette.green : palette.muted)};

  a {
    color: ${palette.green};
  }
`;

export const Card = styled.div`
  background: ${colors.WHITE};
  border: 1px solid ${palette.border};
  border-radius: 14px;
`;

export const EmptyText = styled.p`
  margin: 12px 0 0;
  font-size: 14px;
  color: ${palette.muted};
`;

export const ErrorBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 48px 24px;
  font-size: 15px;
  color: ${colors.GRAY_DARKER};

  button {
    padding: 10px 20px;
    border: none;
    border-radius: 999px;
    font-family: inherit;
    font-size: 14px;
    font-weight: 700;
    color: ${colors.WHITE};
    background: ${colors.GREEN};
    cursor: pointer;
  }
`;
